import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs';

import { LANGUAGE_STORAGE_KEY } from '../../../core/i18n';
import { setCurrentLanguage, setCurrentLanguageSuccess } from './translate.action';

export const setCurrentLanguage$ = createEffect(
    (actions$ = inject(Actions)) =>
        actions$.pipe(
            ofType(setCurrentLanguage),
            tap((action) => localStorage.setItem(LANGUAGE_STORAGE_KEY, action.language)),
            map((action) => setCurrentLanguageSuccess({ language: action.language })),
        ),
    { functional: true },
);
